import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';
import Footer from './Footer';
import { FaCog } from 'react-icons/fa';
import { GameSettingsContext, GameSettingsProvider } from '../contexts/GameSettingsContext';

const AboutPage = () => {
  useEffect(() => {
    document.title = "Wunner - About Us";
  }, []);

  return (
    <div className="about-container">
      <div>
        <Link to="/">
          <img src="/logo.png" alt="Game Logo" className="about-logo" />
        </Link>
      </div>

      <Link to="/settings" className="back-to-settings-button">
        <span className="back-settings-text">Settings</span>
        <FaCog className="back-button-icon" />
      </Link>

      <h1>About Us</h1>
      <h2>Welcome to Wunner</h2>
      <p>Wunner is an interactive movie guessing game that challenges players to identify films from a single screenshot. Our mission is simple: celebrate the art of cinema while testing your movie knowledge in a fun, fast-paced format.</p>

      <h2>Our Story</h2>
      <p>The concept for Wunner began as a passion idea over five years ago, born from a deep love of movies that started early and grew into a lifelong hobby. What began as casual moviegoing evolved into an appreciation for cinema as an art form - from indie darlings to classic blockbusters, foreign films to cult classics.</p>
      <p>We believe that movies are more than entertainment; they're cultural touchstones that connect us across generations and genres. Every frame tells a story, and sometimes a single image can transport you back to an entire film experience.</p>

      <h2>Why the Name?</h2>
      <p>The name "Wunner" is a phonetic play on "oner" - a filmmaking term for a continuous shot done in one take. This reflects our core concept: one frame, one guess. We present you with a single carefully selected screenshot and challenge you to identify the movie within seconds.</p>

      <h3>Our game features:</h3>
      <ul>
        <li>Multiple genres: From comedy and horror to sci-fi and drama</li>
        <li>Diverse eras: Classic films from decades past to recent releases</li>
        <li>Timed challenges: Test your knowledge under pressure</li>
        <li>Streak tracking: See how many you can get right in a row</li>
        <li>Curated content: Every screenshot is thoughtfully selected to be fair but challenging</li>
      </ul>

      <h2>Looking Forward</h2>
      <p>We're constantly working to expand Wunner's features and improve the player experience. Our roadmap includes exciting additions like:</p>
      <ul>
        <li>Multiplayer gameplay similar to popular quiz platforms</li>
        <li>Global leaderboards to compete with movie buffs worldwide</li>
        <li>Expanded movie databases covering even more genres and eras</li>
        <li>Enhanced social features for sharing achievements</li>
      </ul>

      <h2>Our Commitment</h2>
      <p>At Wunner, we're committed to creating a respectful, enjoyable gaming environment for all movie lovers. Whether you're a casual viewer or a serious cinephile, we want every player to discover something new and have fun in the process.</p>

      <h2>Get in Touch</h2>
      <p>Have a suggestion for improving Wunner? Found a bug? Want to recommend movies for inclusion? We'd love to hear from you! Use our contact form to reach out to our team.</p>
      <p>Thank you for playing Wunner and celebrating the magic of movies with us!</p>

      <Footer />
    </div>
  );
};

export default AboutPage;